import { TFunction } from "i18next";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";


export const useTexts = <T = Object>(trans: (t: TFunction) => T): T => {
    const t = useTranslation().t;
    return useMemo(() => trans(t) as ReturnType<typeof trans>, [t, trans]);
}